export function diffObjects(before, after) {
  if (!before && !after) return [];
  if (!before) {
    return Object.keys(after || {}).map(key => ({ key, old: undefined, new: after[key] }));
  }
  if (!after) {
    return Object.keys(before).map(key => ({ key, old: before[key], new: undefined }));
  }
  const keys = new Set([...Object.keys(before), ...Object.keys(after)]);
  const changes = [];
  keys.forEach(key => {
    if (JSON.stringify(before[key]) !== JSON.stringify(after[key])) {
      changes.push({ key, old: before[key], new: after[key] });
    }
  });
  return changes;
}
